import Burger from '@animated-burgers/burger-squeeze';
import '@animated-burgers/burger-squeeze/dist/styles.css';
import { config } from '@fortawesome/fontawesome-svg-core';
import '@fortawesome/fontawesome-svg-core/styles.css';
import {
	faFacebookSquare,
	faInstagram,
	faXTwitter,
	faYoutube
} from '@fortawesome/free-brands-svg-icons';
import { faClone } from '@fortawesome/free-regular-svg-icons';
import { faCheck, faMinus, faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link, graphql, useStaticQuery } from 'gatsby';
import PropTypes from 'prop-types';
import query from 'query-string';
import React, { useContext, useEffect, useState } from 'react';
import { anime } from 'react-anime';
import {
	Accordion,
	AccordionContext,
	useAccordionButton
} from 'react-bootstrap';
import { useMediaQuery } from 'react-responsive';
import { Transition } from 'react-transition-group';
import { getWindow } from 'ssr-window';
import { PageCode } from '../shared';
import './layout.scss';

config.autoAddCss = false;
const ARROW_STATUS = {
	entering: {
		display: 'block',
		opacity: 0
	},
	entered: {
		transition: '.5s ease',
		opacity: 1
	},
	exiting: {
		transition: '.2s ease',
		opacity: 0
	},
	exited: {
		display: 'none'
	}
};
const MENU_STATUS = {
	entering: {
		display: 'block',
		width: 0
	},
	entered: {
		transition: '.3s ease',
		width: '100%'
	},
	exiting: {
		transition: '.3s ease',
		width: 0
	},
	exited: {
		display: 'none'
	}
};
const Toggle = ({ children, eventKey }) => {
	const currentEventKey = useContext(AccordionContext);
	return (
		<li>
			<a
				onClick={useAccordionButton(eventKey)}
				className={eventKey === currentEventKey ? 'active' : ''}
			>
				{children}
			</a>
		</li>
	);
};
export const Layout = ({ children }) => {
	const data = useStaticQuery(graphql`
		query {
			logo: file(relativePath: { eq: "bf-logo.svg" }) {
				publicURL
			}
			word: file(relativePath: { eq: "bf-rogoword.svg" }) {
				publicURL
			}
			wave: file(relativePath: { eq: "topwave.svg" }) {
				publicURL
			}
		}
	`);
	const window = getWindow();
	const location = window.location;
	const storage = window.sessionStorage;
	if (location.pathname === '/') {
		storage.clear();
	}
	const param = query.parse(storage?.getItem('search') as string);
	const [state, setState] = useState({
		q: param.q || '',
		isOpen: false,
		listView: false,
		catAll: false,
		catHero: false,
		catAnime: false,
		catClassic: false,
		catToei: false,
		catOther: false
	});
	const isMobile = useMediaQuery({ query: '(max-width: 667px)' });
	const [y, setY] = useState(0);
	const getScroll = () => {
		setY(window.pageYOffset || window.document.documentElement.scrollTop);
	};
	useEffect(() => {
		window.addEventListener('scroll', getScroll);
		return () => window.removeEventListener('scroll', getScroll);
	}, []);
	useEffect(() => {
		if (state.isOpen) {
			window.document.body.style.overflow = 'hidden';
		} else {
			window.document.body.style.overflow = 'unset';
		}
	}, [state.isOpen]);
	useEffect(() => {
		setState({
			...state,
			listView: location.pathname.replace(/\//g, '') === 'product-list',
			catAll: !param.c || param.c === PageCode.All,
			catHero: param.c === PageCode.Hero,
			catAnime: param.c === PageCode.Anime,
			catClassic: param.c === PageCode.Classic,
			catToei: param.c === PageCode.Toei,
			catOther: param.c === PageCode.Other
		});
	}, [location.pathname, param.c]);
	return (
		<div className="wrapper">
			<header>
				<div
					className="wave"
					style={{ background: `url(${data.wave.publicURL}) center` }}
				></div>
				<div className="header-content">
					<div className="row">
						<ul className="logo">
							<Link to="/">
								<img src={data.logo.publicURL} alt="logo" />
								{!isMobile && (
									<img
										className="name"
										src={data.word.publicURL}
										alt="rogotext"
									/>
								)}
							</Link>
						</ul>
						<div className="form-container">
							<form>
								<dl className="search">
									<dt>
										<input
											type="text"
											className="form-control"
											id="title"
											placeholder="作品名検索"
											value={state.q as string}
											onChange={v =>
												setState({
													...state,
													q: (v.target as any).value
												})
											}
										/>
									</dt>
									<dd>
										<Link
											to={`/product-list?q=${encodeURIComponent(
												state.q as string
											)}&c=${encodeURIComponent(
												(param.c as string) || ''
											)}`}
										>
											<button className="btn mb-2 btn-search rounded-pill">
												<FontAwesomeIcon
													icon={faSearch}
													size="1x"
												/>
												<i className="fas fa-search"></i>
											</button>
										</Link>
									</dd>
								</dl>
							</form>
						</div>
					</div>
					<ul className="categories">
						<p className="label">DVD&amp;Blu-ray</p>
						<div className="group">
							<li className="category">
								<Link
									to={`/product-list?c=${
										PageCode.All
									}&q=${encodeURIComponent(
										state.q as string
									)}`}
									className={`hover-element ${
										state.listView && state.catAll
											? 'active'
											: ''
									}`}
								>
									{state.listView && state.catAll && (
										<FontAwesomeIcon
											icon={faCheck}
											size="1x"
										/>
									)}
									ALL
								</Link>
							</li>
							<li className="category">
								<Link
									to={`/product-list?c=${
										PageCode.Classic
									}&q=${encodeURIComponent(
										state.q as string
									)}`}
									className={`hover-element ${
										state.listView && state.catClassic
											? 'active'
											: ''
									}`}
								>
									{state.listView && state.catClassic && (
										<FontAwesomeIcon
											icon={faCheck}
											size="1x"
										/>
									)}
									昭和の名作
								</Link>
							</li>
							<li className="category">
								<Link
									to={`/product-list?c=${
										PageCode.Anime
									}&q=${encodeURIComponent(
										state.q as string
									)}`}
									className={`hover-element ${
										state.listView && state.catAnime
											? 'active'
											: ''
									}`}
								>
									{state.listView && state.catAnime && (
										<FontAwesomeIcon
											icon={faCheck}
											size="1x"
										/>
									)}
									想い出のアニメ
								</Link>
							</li>
						</div>
						<div className="group">
							<li className="category">
								<Link
									to={`/product-list?c=${
										PageCode.Hero
									}&q=${encodeURIComponent(
										state.q as string
									)}`}
									className={`hover-element ${
										state.listView && state.catHero
											? 'active'
											: ''
									}`}
								>
									{state.listView && state.catHero && (
										<FontAwesomeIcon
											icon={faCheck}
											size="1x"
										/>
									)}
									甦るヒーロー
								</Link>
							</li>
							<li className="category">
								<Link
									to={`/product-list?c=${
										PageCode.Toei
									}&q=${encodeURIComponent(
										state.q as string
									)}`}
									className={`hover-element ${
										state.listView && state.catToei
											? 'active'
											: ''
									}`}
								>
									{state.listView && state.catToei && (
										<FontAwesomeIcon
											icon={faCheck}
											size="1x"
										/>
									)}
									東映作品
								</Link>
							</li>
							<li className="category">
								<Link
									to={`/product-list?c=${
										PageCode.Other
									}&q=${encodeURIComponent(
										state.q as string
									)}`}
									className={`hover-element ${
										state.listView && state.catOther
											? 'active'
											: ''
									}`}
								>
									{state.listView && state.catOther && (
										<FontAwesomeIcon
											icon={faCheck}
											size="1x"
										/>
									)}
									その他
								</Link>
							</li>
						</div>
					</ul>
				</div>
			</header>
			<main>{children}</main>
			<Transition in={y > 300} timeout={{ enter: 0, exit: 200 }}>
				{status => (
					<a
						id="btn-backtotop"
						onClick={() => {
							anime({
								targets:
									window.document.scrollingElement ||
									window.document.body ||
									window.document.documentElement,
								scrollTop: 0,
								dulation: 600,
								easing: 'easeOutCubic'
							});
						}}
						style={ARROW_STATUS[status]}
					>
						<span className="arrow arrow_up"></span>
					</a>
				)}
			</Transition>
			<div
				className="opener"
				onClick={() => setState({ ...state, isOpen: !state.isOpen })}
			>
				<Burger isOpen={state.isOpen} />
			</div>
			<Transition in={state.isOpen} timeout={{ enter: 0, exit: 0 }}>
				{status => (
					<div id="menu-content" style={MENU_STATUS[status]}>
						<nav>
							<ul>
								<Accordion defaultActiveKey="0">
									<li>
										<Link
											to="/"
											onClick={() =>
												setState({
													...state,
													isOpen: false
												})
											}
										>
											HOME
										</Link>
									</li>
									<Toggle eventKey="3">DVD&Blu-ray</Toggle>
									<Accordion.Collapse eventKey="3">
										<div className="navsub">
											<Link
												to="/product-list?c=classic"
												onClick={() =>
													setState({
														...state,
														isOpen: false
													})
												}
											>
												昭和の名作
											</Link>
											<Link
												to="/product-list?c=anime"
												onClick={() =>
													setState({
														...state,
														isOpen: false
													})
												}
											>
												想い出のアニメ
											</Link>
											<Link
												to="/product-list?c=hero"
												onClick={() =>
													setState({
														...state,
														isOpen: false
													})
												}
											>
												甦るヒーロー
											</Link>
											<Link
												to="/product-list?c=toei"
												onClick={() =>
													setState({
														...state,
														isOpen: false
													})
												}
											>
												東映作品
											</Link>
											<Link
												to="/product-list?c=other"
												onClick={() =>
													setState({
														...state,
														isOpen: false
													})
												}
											>
												その他
											</Link>
										</div>
									</Accordion.Collapse>
									<li>
										<Link
											to="/information-list"
											onClick={() =>
												setState({
													...state,
													isOpen: false
												})
											}
										>
											INFORMATION
										</Link>
									</li>
									<Toggle eventKey="1">
										企画・プロデュース作品
									</Toggle>
									<Accordion.Collapse eventKey="1">
										<div className="navsub">
											<Link
												to="/shampoo"
												onClick={() =>
													setState({
														...state,
														isOpen: false
													})
												}
											>
												シャンプー王⼦
											</Link>
											<Link
												to="/monchitchen"
												onClick={() =>
													setState({
														...state,
														isOpen: false
													})
												}
											>
												ベビチッチえいご
											</Link>
											<Link
												to="/monchitch"
												onClick={() =>
													setState({
														...state,
														isOpen: false
													})
												}
											>
												モンチッチ
											</Link>
											<Link
												to="/wvs"
												onClick={() =>
													setState({
														...state,
														isOpen: false
													})
												}
											>
												THE WITCH VILLAGE STORY
											</Link>
											<a
												href="http://www.gonzo.co.jp/archives/majikano/"
												target="_blank"
												className="underline"
												rel="noreferrer"
											>
												マジカノ
												<FontAwesomeIcon
													icon={faClone}
													size="1x"
												/>
											</a>
										</div>
									</Accordion.Collapse>
									<Toggle eventKey="2">
										キャラクター展開
									</Toggle>
									<Accordion.Collapse eventKey="2">
										<div className="navsub">
											<Link to="/pudel-poodle">
												Pudel Piidle
											</Link>
											<Link to="/kosodoro-neko/top">
												こそどろねこ
											</Link>
										</div>
									</Accordion.Collapse>
								</Accordion>
							</ul>
						</nav>
					</div>
				)}
			</Transition>
			<footer>
				<div className="footer__f-link">
					<Link to="/company" className="link">
						<FontAwesomeIcon icon={faMinus} size="1x" /> 会社概要
					</Link>
					<Link to="/privacy-policy" className="link">
						<FontAwesomeIcon icon={faMinus} size="1x" />
						プライバシーポリシー
					</Link>
				</div>
				<p className="text-darkgray text-s">
					※各ページに掲載されている画像の無断転載を禁じます。
				</p>
				<div className="sns-link">
					<a
						href="https://twitter.com/BF_yomigaeru"
						target="_blank"
						rel="noreferrer"
					>
						<FontAwesomeIcon icon={faXTwitter} size="1x" />
					</a>
					<a
						href="https://www.facebook.com/bestfieldPR/"
						target="_blank"
						rel="noreferrer"
					>
						<FontAwesomeIcon icon={faFacebookSquare} size="1x" />
					</a>
					<a
						href="https://www.instagram.com/bf_yomigaeru/"
						target="_blank"
						rel="noreferrer"
					>
						<FontAwesomeIcon icon={faInstagram} size="1x" />
					</a>
					<a
						href="https://www.youtube.com/channel/UCUcsDOMvj5Bn9-dMvaYgQ0w"
						target="_blank"
						rel="noreferrer"
					>
						<FontAwesomeIcon icon={faYoutube} size="1x" />
					</a>
				</div>
				<p>
					<i className="far fa-copyright"></i>
					株式会社ベストフィールド
				</p>
			</footer>
		</div>
	);
};

Layout.propTypes = {
	children: PropTypes.node.isRequired
};
